// extracted by mini-css-extract-plugin
export default {"wrapper":"ds-z","response":"es-z","error":"fs-z","disabled":"gs-z","buttons":"hs-z","feedbackQuestionSection":"is-z","yesNoWrapper":"js-z"};